import store from "@/store";

// 辅助函数：根据条件切换按钮状态
function toggleButtonState(el, value) {
  // 如果传入了值，并且是对象类型，且包含 isDisabled 属性，则使用传入的值
  // 否则，使用 store.getters.EditRead
  let isDisabled;

  if (value !== undefined && value !== null) {
    if (typeof value === "boolean") {
      isDisabled = value;
    } else if (typeof value === "object" && "isDisabled" in value) {
      isDisabled = value.isDisabled;
    } else {
      console.warn(
        "lockEdit 指令接收的值格式不正确，应为布尔值或包含 isDisabled 属性的对象"
      );
      isDisabled = false;
    }
  } else {
    // 使用 store.getters.EditRead 作为默认值
    // 假设 EditRead 返回一个布尔值，表示是否为只读状态
    isDisabled = store.getters.EditRead;
  }

  // 根据 isDisabled 状态切换类和禁用属性
  if (isDisabled) {
    el.classList.add("is-disabled");
    el.disabled = true;
  } else {
    el.classList.remove("is-disabled");
    el.disabled = false;
  }
}
// 数字指令
const inputDeliver = {
  bind(el, binding, vnode) {
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    input.addEventListener("compositionstart", () => {
      vnode.locking = true;
    });
    input.addEventListener("compositionend", () => {
      vnode.locking = false;
      input.dispatchEvent(new Event("input"));
    });

    const handleBlur = () => {
      if (vnode.locking) {
        return;
      }
      // v-input.num
      if (binding.modifiers.num) {
        // 只能输入数字（开头可以多个0）
        onlyNum(input);
      }
      // v-input.num_point
      else if (binding.modifiers.num_point) {
        // 只能输入数字+小数点（可以多个小数点）
        onlyNumPoint(input);
      }
      // v-input.float
      else if (binding.modifiers.float) {
        // 只能输入浮点型（只能一个小数点）
        onlyFloat(input, binding.value);
      }
      // v-input.int
      else if (binding.modifiers.int) {
        // 只能输入整数（0+正整数）（开头不能多个0）
        onlyInt(input);
      }
      // v-input.intp
      else if (binding.modifiers.intp) {
        // 只能输入正整数
        onlyIntp(input);
      }
      // v-input.alp
      else if (binding.modifiers.alp) {
        // 只能输入字母
        onlyAlp(input);
      }
      // v-input.num_alp
      else if (binding.modifiers.num_alp) {
        // 只能输入数字+字母
        onlyNumAlp(input);
      }
      // v-input.arith
      else if (binding.modifiers.arith) {
        // 四则运算符+数字
        onlyArith(input);
      }
      input.dispatchEvent(new Event("input"));
    };
    input.addEventListener("blur", handleBlur);

    // 数字
    function onlyNum(input) {
      input.value = input.value.replace(/\D+/g, "");
    }
    // 整数(0+正整数)
    function onlyInt(input) {
      let value = input.value;
      value = value.replace(/\D+/g, "");
      input.value = value ? Number(value).toString() : value; // 去掉开头多个0
    }
    // 正整数
    function onlyIntp(input) {
      if (!/^[1-9][0-9]*$/.test(input.value)) {
        let value = input.value?.split(".")[0] || "";
        // console.log("value", value);
        // let value = input.value.replace(/\D+/g, "");
        if (value && value.substring(0, 1) === "0") {
          // 0开头去除0
          value = value.substring(1);
        }

        input.value = value;
      }
    }

    // 数字+小数点+负号
    function onlyNumPoint(input) {
      input.value = input.value.replace(/[^\d.\-]/g, "");
    }

    // 浮点型
    // eslint-disable-next-line no-unused-vars
    function onlyFloat(input, n) {
      let value = input.value;
      value = value.replace(/[^\d.\-]/g, "");
      value = value.replace(/^\./g, "");
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      if (n && Number(n) > 0) {
        // 限制n位
        var d = new Array(Number(n)).fill(`\\d`).join("");
        // eslint-disable-next-line no-useless-escape
        var reg = new RegExp(`^(\\-)*(\\d+)\\.(${d}).*$`, "ig");
        value = value.replace(reg, "$1$2.$3");
      }
      if (value && !value.includes(".")) {
        value = Number(value).toString(); // 去掉开头多个0
      }
      input.value = value;
    }
    // 字母
    function onlyAlp(input) {
      input.value = input.value.replace(/[^A-Za-z]/g, "");
    }
    // 数字+字母
    function onlyNumAlp(input) {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, "");
    }
    // 四则运算+-*/()数字
    function onlyArith(input) {
      const value = input.value;
      if (value) {
        input.value = value.split("").reduce((prev, cur) => {
          // eslint-disable-next-line no-useless-escape
          if (/^[\d|\-|\+|\*|\/|\.|\(|\)]+$/.test(cur)) {
            return prev + cur;
          }
          return prev;
        }, "");
      }
    }
  },
};
const limitInput = {
  bind: function (el, binding) {
    const [decimalPlaces, digitLimit] = binding.value;
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    const handleInput = function (event) {
      let value = event.target.value;
      if (value === "") return;
      // 去除非数字、非小数点和非负号字符
      value = value.replace(/[^0-9.\-]/g, "");
      // 确保只有一个小数点
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
      // 确保小数点后最多指定的位数
      if (parts.length === 2 && parts[1].length > decimalPlaces) {
        parts[1] = parts[1].slice(0, decimalPlaces);
        value = parts.join(".");
      }
      event.target.value = value;
    };

    const handleBlur = function (event) {
      let value = event.target.value;
      if (value === "") return;
      const parts = value.split(".");
      // 去除多余的小数点
      if (parts.length > 1 && parts[1] === "") {
        value = parts[0];
      }
      // 处理空值
      if (value === "") {
        value = "0";
      }
      // 通过字符串判断是否超过指定的位数
      const integerPart = parts[0];
      const maxValue = "9".repeat(digitLimit);
      if (
        integerPart.length > digitLimit ||
        (integerPart.length === digitLimit && integerPart > maxValue)
      ) {
        value = maxValue + "." + "9".repeat(decimalPlaces);
      }
      const partsAfter = value.split(".");
      // 去除多余的小数点
      if (partsAfter.length > 1 && partsAfter[1] === "") {
        value = partsAfter[0];
      }
      event.target.value = value;
    };

    input.addEventListener("input", handleInput);
    input.addEventListener("blur", handleBlur);
  },
  unbind: function (el) {
    const handleInput = el.__handleInput;
    const handleBlur = el.__handleBlur;
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    if (handleInput) {
      input.removeEventListener("input", handleInput);
    }
    if (handleBlur) {
      input.removeEventListener("blur", handleBlur);
    }
  },
};
const limitRange = {
  bind: function (el, binding) {
    const [minValue, maxValue, decimalPlaces, isLimit] = binding.value;
    const handleInput = function (event) {
      let value = event.target.value;
      if (value === "") return;
      // 去除非数字、非小数点和非负号字符
      value = value.replace(/[^0-9.\-]/g, "");
      // 确保只有一个小数点
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
      // 确保小数点后最多指定的位数
      if (parts.length === 2 && parts[1].length > decimalPlaces) {
        parts[1] = parts[1].slice(0, decimalPlaces);
        value = parts.join(".");
      }
      event.target.value = value;
    };

    const handleBlur = function (event) {
      let value = event.target.value;
      if (value === "") return;
      const parts = value.split(".");
      // 去除多余的小数点
      if (parts.length > 1 && parts[1] === "") {
        value = parts[0];
      }
      const numValue = parseFloat(value);
      const min = parseFloat(minValue);
      let max = parseFloat(maxValue);
      if (isLimit) {
        const minDecimal = 1 / 10 ** decimalPlaces;
        max = max - minDecimal;
      }
      if (isNaN(numValue)) {
        value = min.toString();
      } else if (numValue < min) {
        value = min.toString();
      } else if (numValue > max) {
        value = max.toString();
      }

      // 确保最终结果小数位数符合要求
      const decimalPart = value.split(".")[1];
      if (decimalPart && decimalPart.length > decimalPlaces) {
        const integerPart = value.split(".")[0];
        value = `${integerPart}.${decimalPart.slice(0, decimalPlaces)}`;
      }
      event.target.value = value;
    };
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    input.addEventListener("input", handleInput);
    input.addEventListener("blur", handleBlur);
  },
  unbind: function (el) {
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    const handleInput = el.__handleInput;
    const handleBlur = el.__handleBlur;
    if (handleInput) {
      input.removeEventListener("input", handleInput);
    }
    if (handleBlur) {
      input.removeEventListener("blur", handleBlur);
    }
  },
};
// 全局自定义指令
export default {
  // 指令名: 生命周期
  errorimg: {
    // 这个生命周期只执行一次，要是后面更新有其它问题也需要解决，
    // 如果图片img没有src,它是不会报错的  也要给它默认图片
    inserted(dom, obj) {
      // 当你图片有src，就使用你的src,没有就使用默认图片
      // 如果图片加载出问题，指定头像
      dom.src = dom.src || obj.value || require("@/assets/images/photo.jpg");
      // 图片出错了,这是一个监听函数，执行一次后会一直存在
      dom.onerror = () => {
        // 图片加载出错时会执行
        // 如果出错了，就给它一个默认图片
        dom.src = obj.value || require("@/assets/images/photo.jpg");
      };
    },
    // 当指令所在组件有更新且更新完成后执行
    componentUpdated(dom, obj) {
      dom.src = dom.src || obj.value || require("@/assets/images/photo.jpg");
    },
  },
  focus: {
    inserted(el, { modifiers: { noKeyboard } }) {
      try {
        const tagName = el.tagName;
        if (tagName !== "INPUT") {
          const child = el.children[0];
          if (child && child.tagName === "INPUT") {
            el = child;
          }
        }
        el.focus();
        // 不弹起软键盘
        if (noKeyboard) {
          el.setAttribute("readonly", "readonly");
          var timer = null;
          timer = setTimeout(() => {
            el.removeAttribute("readonly");
            clearTimeout(timer);
          }, 100);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  // 全局防抖-仅按钮
  debounce: {
    inserted(el, binding) {
      el.addEventListener("click", (e) => {
        el.classList.add("is-disabled");
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
          el.classList.remove("is-disabled");
        }, 500); // 我这里设置的是500毫秒也就是0.5秒
      });
    },
  },
  // 全局防抖-所有
  clickLock: {
    inserted(el, binding) {
      // 获取防抖时间，默认1000毫秒
      const delay = binding.arg ? parseInt(binding.arg) : 500;
      // 获取传入的回调函数
      const callback = binding.value;

      if (typeof callback !== "function") {
        console.warn("v-clickLock 指令需要一个函数作为值");
        return;
      }

      // 定义一个标志位来控制防抖
      let isDebounced = false;
      // 存储定时器 ID
      let timeoutId = null;

      // 定义事件处理函数
      const handler = function (event) {
        if (isDebounced) {
          // 如果已经在防抖期间，阻止默认行为并返回
          event.preventDefault();
          return;
        }

        // 执行回调函数
        callback(event);
        // 设置防抖标志位
        isDebounced = true;
        // 添加禁用样式
        el.classList.add("is-disabled");

        // 在指定时间后重置防抖状态
        timeoutId = setTimeout(() => {
          isDebounced = false;
          el.classList.remove("is-disabled");
          timeoutId = null; // 清除定时器引用
        }, delay);
      };

      // 绑定点击事件
      el.addEventListener("click", handler);

      // 存储 handler 和 timeoutId 以便在 unbind 时移除
      el.__clickLock__ = {
        handler,
        timeoutId,
      };
    },
    unbind(el) {
      if (el.__clickLock__) {
        const { handler, timeoutId } = el.__clickLock__;
        // 移除事件监听器
        el.removeEventListener("click", handler);
        // 清除定时器
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        // 删除存储的属性
        delete el.__clickLock__;
      }
    },
  },

  // 全局指令：lockEdit 用于绘图界面启用禁用状态  为true禁用 为false启用 不传默认调取vuex数据
  lockEdit: {
    // 当指令绑定到元素上时调用
    inserted(el, binding) {
      // 初始化按钮状态
      toggleButtonState(el, binding.value);
    },

    // 当绑定的值更新时调用
    update(el, binding) {
      // 更新按钮状态
      toggleButtonState(el, binding.value);
    },

    // 当指令与元素解绑时调用
    unbind(el) {
      // 如果有其他清理操作，可以在这里处理
    },
  },
  input: inputDeliver,
  "limit-input": limitInput,
  "limit-ranger": limitRange,
};
